import { useId } from "@utdanningsdirektoratet/utils/useId";
import { useCallback } from "react";
import { show, close } from "./PopinManager";

const usePopin = (_id?: string): [id: string, show: () => void, close: () => void] => {
  const id = useId(_id);
  const showPopin = useCallback(() => show(id), [id]);
  const closePopin = useCallback(() => close(id), [id]);
  return [id, showPopin, closePopin];
};

export default usePopin;
